









































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { ModelSync, Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import RemovableBadge from '@/modules/shared/components/shared/badge/RemovableBadge.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseButtonDropdown from '@/modules/shared/components/shared/kit/BaseButtonDropdown.vue'
import Overlay from '@/modules/shared/components/shared/overlay/Overlay.vue'
import PanelContentItemShowTabular from '@/modules/content-item/components/panel/PanelContentItemShowTabular.vue'
import ContentItemInformationTable from '@/modules/content-item/components/shared/ContentItemInformationTable.vue'
import { ContentItemResourceType, ContentItemStatus } from '@/modules/content-item/models/content-item-resource.model'
import ContentDownloadDropDown from '@/modules/shared/components/shared/ContentDownloadDropDown.vue'
import { PanelContentItemRoute } from '@/modules/content-item/routes/panel-content-item.route'
import { ContentFormat } from '@/modules/content/models/content-resource.model'
import PanelContentItemShowContentButton
  from '@/modules/content-item/components/panel/PanelContentItemShowContentButton.vue'

@Component({
  components: {
    PanelContentItemShowContentButton,
    ContentDownloadDropDown,
    ContentItemInformationTable,
    PanelContentItemShowTabular,
    Overlay,
    BaseButtonDropdown,
    BaseButton,
    RemovableBadge,
    TabularHeader,
    Modal
  }
})
export default class PanelContentItemShowModal extends Vue {
  constructor(
    private readonly routes: PanelContentItemRoute
  ) {
    super()
  }

  @Prop() contentItem!: ContentItemResourceType
  @ModelSync('value', 'input') modal!: boolean
  @Prop() label!: string
  private contentFormat = ContentFormat

  private get showActionButtons() {
    switch (this.contentItem.data.status) {
      case ContentItemStatus.COMPLETED:
      case ContentItemStatus.REJECTED:
        return true
      default:
        return false
    }
  }

}
